var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.format(_vm.source.time)))]),_vm._v(" "),_c('span',{directives:[{name:"clean-html",rawName:"v-clean-html",value:(_vm.source.msg),expression:"source.msg"}],staticClass:"msg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }